const prefix = 'customer';

export const CREATE_CUSTOMER = `${prefix}/CREATE_CUSTOMER`;
export const SAVE_CUSTOMER = `${prefix}/SAVE_CUSTOMER`;
export const SET_FIELD_VALUE = `${prefix}/SET_FIELD_VALUE`;
export const SET_LOADING = `${prefix}/SET_LOADING`;
export const SET_CUSTOMER = `${prefix}/SET_CUSTOMER`;
export const SET_VISIBILITY = `${prefix}/SET_VISIBILITY`;
export const CLOSE_DIALOG = `${prefix}/CLOSE_DIALOG`;
